import React from 'react';
import { Box, Card, CardContent, IconButton, Typography } from '@mui/material';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { Close } from '@mui/icons-material';
import { IMetadataLogin } from '../../Interfaces/IMetadataLogin';

export interface IChartData {
  name: string;
  value: number;
}

interface IProps {
  keyName: string;
  metadataLoginArray: IMetadataLogin[];
  activeDashboard: string[];
  setActiveDashboard: Function;
}

export const PieChartBrowsers: React.FC<IProps> = ({
  keyName,
  metadataLoginArray,
  activeDashboard,
  setActiveDashboard,
}) => {
  const uniqueBrowsers = Array.from(
    new Set(metadataLoginArray.map(login => login.Browser))
  );

  const COLORS = [
    '#ff5733', // Rote Farbe
    '#33ff57', // Grüne Farbe
    '#3357ff', // Blaue Farbe
    '#ff33a1', // Pinke Farbe
    '#f0e130', // Gelbe Farbe
    '#ff6347', // Tomatenrot
    '#00bfff', // Tiefes Blau
    '#ff1493', // Tiefes Pink
    '#2e8b57', // Meergrün
    '#8a2be2', // Blauviolett
    '#d2691e', // Schokoladenbraun
    '#ff4500', // Orangerot
    '#20b2aa', // Lachsblau
    '#f0f8ff', // Alice Blau
    '#9370db', // Mittelviolett
    '#ff8c00', // Dunkelorange
    '#adff2f', // Grüngelb
    '#00ced1', // Türkisblau
    '#c71585', // Mittelviolettrot
  ];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = (props: any) => {
    const radius =
      Number(props['innerRadius']) +
      (Number(props['outerRadius']) - Number(props['innerRadius'])) * 0.5;
    const x =
      Number(props['cx']) +
      radius * Math.cos(-Number(props['midAngle']) * RADIAN);
    const y =
      Number(props['cy']) +
      radius * Math.sin(-Number(props['midAngle']) * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill='white'
        textAnchor={x > Number(props['cx']) ? 'start' : 'end'}
        dominantBaseline='central'
      >
        {`${(Number(props['percent']) * 100).toFixed(0)}%`}
      </text>
    );
  };

  const chartData = () => {
    const returnArray: IChartData[] = [];
    uniqueBrowsers.map(x =>
      returnArray.push({
        name: x,
        value: metadataLoginArray.filter(login => login.Browser === x).length,
      })
    );
    return returnArray;
  };

  const onRemove = () => {
    setActiveDashboard([...activeDashboard.filter(x => x !== keyName)]);
  };

  return (
    <Card variant='outlined'>
      <IconButton sx={{ float: 'right' }} onClick={onRemove}>
        <Close sx={{ fontSize: 14 }} />
      </IconButton>
      <CardContent>
        <Box sx={{ display: 'flex' }}>
          <Typography>Browserverteilung</Typography>
        </Box>
        <Box
          sx={{
            height: { xs: 150, sm: 250, xl: 300 },
            mt: 2,
            minWidth: 300,
            width: '100%',
          }}
        >
          <ResponsiveContainer width='100%' height='100%'>
            <PieChart>
              <Pie
                data={chartData()}
                cx='50%'
                cy='45%' // etwas höher setzen, um Platz für Legende unten zu schaffen
                labelLine={false}
                outerRadius='80%'
                fill='#4cb1ad'
                dataKey='value'
                label={renderCustomizedLabel}
              >
                {chartData().map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Legend
                layout='horizontal'
                verticalAlign='bottom'
                align='center'
              />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};
